// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
 

  url: 'https://odep.saferoads.ph',
  cmsServiceURL: 'https://odep-saferoadsph-reports-service-legacy.azurewebsites.net/api/v1',
  userServiceURL: 'https://odep-saferoadsph-user-service-legacy.azurewebsites.net/api/v1',
  courseServiceURL:
    'https://odep-saferoadsph-module-service-legacy.azurewebsites.net/api/v1',
  paymentServiceURL:
    'https://odep-saferoadsph-payment-service-legacy.azurewebsites.net/api/v1',
  dsControlPanelURL:'https://odep.ad.saferoads.ph/',
  mayaWebHookServiceURL:
    'https://odep-saferoadsph-payment-service-legacy.azurewebsites.net/api/v1/maya',   

  luxandURL: 'https://api.luxand.cloud',

  azureFaceApiEndPoint: 'https://saferoadsph.cognitiveservices.azure.com/',

  paymongoURL: 'https://api.paymongo.com/v1/',

  paymayaURL: 'https://pg.maya.ph/checkout/v1/', 


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
